function Viza(container){
	var _this = this;
	this.container = $(container);
	this.vizaInner = this.container.find('.viza-inner');
	this.slideDown = this.container.find('.j-viza-slidedown');
	this.slideUp = this.container.find('.j-viza-slideup').hide();
	this.container.bind({
		mouseenter: function(){
			_this.slideDown.stop().animate({opacity: 1},{queue: false, duration: 300});
		},
		mouseleave: function(){
			_this.slideDown.stop().animate({opacity: 0},{queue: false, duration: 300});
		}
	});
	this.slideDown.click(function(){
		_this.vizaInner.height('100%');
		_this.slideDown.hide();
		_this.slideUp.show();
		return false;
	});
	this.slideUp.click(function(){
		_this.vizaInner.height(150);
		_this.slideUp.hide();
		_this.slideDown.show();

		var controlScrollTop = container.offset().top,
			pageScrollTop = $('html').scrollTop() + $('body').scrollTop();
		if (pageScrollTop > controlScrollTop) {
			$('html,body').scrollTop(controlScrollTop);
		}

		return false;
	});
}
if (typeof define === "function" && define.amd) {
	define('Controls/Viza',[], function() {
		return Viza;
	});
};
